import { render, staticRenderFns } from "./ProducerAssortimentComponent.vue?vue&type=template&id=6b5085d8&scoped=true"
import script from "./ProducerAssortimentComponent.vue?vue&type=script&lang=js"
export * from "./ProducerAssortimentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5085d8",
  null
  
)

export default component.exports